import React from 'react'
import { Box, Divider, Grid, Typography } from '@mui/material'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import FixedWidthContainer from 'components/FixedWidthContainer'
import FooterLink from 'components/FooterLink'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()
  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: '#302F2F',
        pt: 9
      }}
    >
      <FixedWidthContainer sx={{ pb: 8 }}>
        <Grid container spacing={6}>
          <Grid item xs={3}>
            <Typography
              variant='h2'
              sx={{ mb: 2, fontFamily: 'Playfair Display', color: '#FFFFFF' }}
            >
              {t('footer.information')}
            </Typography>
            <Box
              sx={{ width: '40px', borderTop: '1px solid #FFFFFF', mb: 2 }}
            />
            <FooterLink to='/our-products'>{t('footer.products')}</FooterLink>
            <FooterLink to='/about-us'>{t('footer.aboutUs')}</FooterLink>
            <FooterLink to='/contact-us'>{t('footer.contactUs')}</FooterLink>
            <Box
              sx={{ mt: 6, display: 'flex', gap: 1.5, alignItems: 'center' }}
            >
              <Box
                component='img'
                src='/test_quality_logo.png'
                alt='Test Quality Logo'
                sx={{ maxWidth: '38%' }}
              />
              <Box
                component='img'
                src='/carb_logo.png'
                alt='CARB OK Logo'
                sx={{ maxWidth: '38%' }}
              />
              <Box
                component='img'
                src='/bbb_logo.png'
                alt='BBB Logo'
                sx={{ maxWidth: '38%' }}
              />
            </Box>
          </Grid>

          <Grid item xs={3}>
            <Typography
              variant='h2'
              sx={{ mb: 2, fontFamily: 'Playfair Display', color: '#FFFFFF' }}
            >
              {t('footer.ourPolicies')}
            </Typography>
            <Box
              sx={{ width: '40px', borderTop: '1px solid #FFFFFF', mb: 2 }}
            />
            <FooterLink to='/privacy-policy'>
              {t('footer.privacyPolicy')}
            </FooterLink>
            <FooterLink to='/warranty'>{t('footer.warranty')}</FooterLink>
            <FooterLink to='/return-refund-policy'>
              {t('footer.returnRefundPolicy')}
            </FooterLink>
            <FooterLink to='/terms-conditions'>
              {t('footer.termsConditions')}
            </FooterLink>
          </Grid>

          <Grid item xs={6}>
            <Box
              component='img'
              sx={{ width: '200px', mb: 4 }}
              alt='Company Logo'
              src='/logo_white.png'
            />
            <iframe
              title='Muses Cabinets showroom location map'
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3313.3548291489074!2d-117.95950172274942!3d33.854745273232176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dd2a26f436111f%3A0xbe33e6b234c109!2s2760%20S%20Pacific%20Dr%2C%20Fullerton%2C%20CA%2092833!5e0!3m2!1sen!2sus!4v1720811772820!5m2!1sen!2sus'
              style={{
                border: 0,
                width: '100%',
                height: '160px',
                borderRadius: '8px',
                display: 'block'
              }}
              allowFullScreen
              loading='lazy'
            />
            <Typography variant='h4' sx={{ color: '#FFFFFF', mt: 2 }}>
              Atlanta, GA
            </Typography>
            <Typography
              variant='body1'
              sx={{ fontWeight: 300, color: '#FFFFFF', mt: 0.5, mb: 2.5 }}
            >
              2760 Pacific Drive, Suite A, Norcross, GA 30071
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <a
                href='https://www.facebook.com/musesusa'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Box
                  sx={{
                    width: '43px',
                    height: '43px',
                    borderRadius: '10px',
                    backgroundColor: '#A11E20',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'opacity 0.2s',
                    '&:hover': { opacity: 0.8 }
                  }}
                >
                  <FacebookIcon
                    style={{ color: '#F4F4F4', width: '26px', height: '26px' }}
                  />
                </Box>
              </a>
              <a
                href='https://www.instagram.com/muses_usa/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Box
                  sx={{
                    width: '43px',
                    height: '43px',
                    borderRadius: '10px',
                    backgroundColor: '#A11E20',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'opacity 0.2s',
                    '&:hover': { opacity: 0.8 }
                  }}
                >
                  <InstagramIcon
                    style={{ color: '#F4F4F4', width: '26px', height: '26px' }}
                  />
                </Box>
              </a>
            </Box>
          </Grid>
        </Grid>
      </FixedWidthContainer>

      <Divider sx={{ width: '100%', mt: 3, borderColor: '#585858' }} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          py: 3,
          height: '70px'
        }}
      >
        <Typography
          variant='body1'
          sx={{
            textAlign: 'center',
            color: '#B8B4B4'
          }}
        >
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </Typography>
      </Box>
    </Box>
  )
}

export default Footer
